import { useIntl } from 'react-intl';

import messages from '@/components/emotion-detector/messages';
import { formatResizedUrl } from '@/utils/app/formatResizedUrl';

import {
	GuideCopy,
	GuideInfo,
	GuideThumbnail,
	GuideThumbnailContainer,
	GuideTitle,
	ProgramTitle,
} from '../styles';
import { CurrentAudio } from '../types';
import { getDurationInMinutes } from '../utils';

interface GuideInfoDisplayProps {
	currentAudio: CurrentAudio;
}

export default function GuideInfoDisplay({ currentAudio }: GuideInfoDisplayProps) {
	const { formatMessage } = useIntl();

	return (
		<GuideInfo isVisible={Boolean(currentAudio.title)}>
			{currentAudio.thumbnailUrl && (
				<GuideThumbnailContainer>
					<GuideThumbnail
						src={formatResizedUrl(currentAudio.thumbnailUrl, 128, 128)}
						height={128}
						width={128}
						alt={formatMessage(messages.audioPlayerThumbnailAlt)}
					/>
				</GuideThumbnailContainer>
			)}
			<GuideCopy>
				<GuideTitle>{currentAudio.title}</GuideTitle>
				<ProgramTitle>
					{currentAudio.programTitle || `${getDurationInMinutes(currentAudio.duration)} minutes`}
				</ProgramTitle>
			</GuideCopy>
		</GuideInfo>
	);
}
